// Mock Socket Service - No actual socket connection
import { useSocketStatusStore } from "@/store/socketStatus";

// Mock socket object
const mockSocket = {
  connected: true,
  disconnected: false,
  active: true,
  id: 'mock-socket-id',
  io: {
    engine: {
      transport: { name: 'mock' }
    }
  },
  on: () => {},
  off: () => {},
  emit: () => {},
  connect: () => {},
  disconnect: () => {},
};

let navigateFunction = null;

export function setNavigate(navigate) {
  navigateFunction = navigate;
}

export function getSocket() {
  // Set connected state in store
  setTimeout(() => {
    useSocketStatusStore.getState().setConnected(true);
    useSocketStatusStore.getState().setConnecting(false);
  }, 100);
  return mockSocket;
}

// All event handlers return empty cleanup functions
export function onPricesUpdate(handler) {
  return () => {};
}

export function onPricesDiff(handler) {
  return () => {};
}

export function onRolePricesUpdated(handler) {
  return () => {};
}

export function onProductStatusChanged(handler) {
  return () => {};
}

export function onBasePricesUpdated(handler) {
  return () => {};
}

export function onOrderStatusChanged(handler) {
  return () => {};
}

export function onPricesOrderChanged(handler) {
  return () => {};
}

export function onAutoOrderExecuted(handler) {
  return () => {};
}

export function onNewUserRegistration(handler) {
  return () => {};
}

export function onPendingCountUpdate(handler) {
  return () => {};
}

export function onOrderCreated(handler) {
  return () => {};
}

export function onOrderUpdated(handler) {
  return () => {};
}

export function onPendingOrdersCountUpdate(handler) {
  return () => {};
}

export function joinAdminRoom() {}

export function leaveAdminRoom() {}

export function onUserOnlineStatus(handler) {
  return () => {};
}
